import { useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import React from 'react';
import api from '../../../../../components/api';

function useClientsDetailAddHeader() {
  const { clientId } = useParams();

  const { data: clientByIdRes } = useQuery(
    ['getById', 'clients', clientId],
    () => api.clients.getById(clientId!),
    {
      enabled: !!clientId,
    },
  );

  const clientById: {name: string} | undefined = React.useMemo(() => {
    const resData = clientByIdRes?.data?.data;
    if (resData) {
      return {
        name: resData.name,
      };
    }
    return undefined;
  }, [clientByIdRes]);

  const currentTitle:string = React.useMemo(() => {
    const path = window.location.pathname.split('/');
    if (path[2] === 'contact') {
      if (path.length === 5) return 'Edit Contact';
      return 'Add Contact Person';
    }
    if (path[2] === 'partner') {
      if (path.length === 5) return 'Edit Partner';
      return 'Add Partner';
    }
    if (path[2] === 'invoice') return 'Paid Invoices';
    if (path[2] === 'coffee-invoice') return 'Coffee Paid Invoices';
    if (path[2] === 'view-coffee-invoice') return 'Coffee Invoice Detail';
    if (path[2] === 'add') return 'Edit Client';
    return 'No Path Found';
  }, [window.location.pathname]);

  return {
    clientId, clientById, currentTitle,
  };
}

export default useClientsDetailAddHeader;
